import React from "react";
import "./ComparisonTable.css";

const ComparisonTable = ({ title, columns, data }) => {
    return (
        <div className="table-container">
            {title && <h2 className="table-title">{title}</h2>}
            <table className="comparison-table">
                <thead>
                <tr>
                    {columns.map((col, idx) => (
                        <th key={idx}>{col}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex} className={rowIndex % 2 === 0 ? "even-row" : "odd-row"}>
                        {columns.map((col, colIndex) => (
                            <td key={colIndex}>{row[col]}</td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default ComparisonTable;
